module.exports = __webpack_public_path__ + "img/_Slide10.f99d53eb.jpg";